__turbopack_context__.v({
  "footerCopyright": "SecondaryFooter-module-scss-module__Ab1L7W__footerCopyright",
  "footerHiddenAccessible": "SecondaryFooter-module-scss-module__Ab1L7W__footerHiddenAccessible",
  "footerLinksContainer": "SecondaryFooter-module-scss-module__Ab1L7W__footerLinksContainer",
  "footerLogo": "SecondaryFooter-module-scss-module__Ab1L7W__footerLogo",
  "secondaryFooter": "SecondaryFooter-module-scss-module__Ab1L7W__secondaryFooter",
});
